//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import PluginSurfaceFrame from '@/components/Elements/PluginSurfaceFrame';
import { type PluginWebviewSurface } from '@/services/apiTypes';

interface PluginPanelBodyProps {
  surface: PluginWebviewSurface;
  pluginName: string;
}

/**
 * A plugin's web-view surface, drawn as the contents of a floating panel.
 *
 * Unlike the modal presentation, the frame fills whatever the panel has been
 * resized to -- the panel owns the sizing, and the plugin owns the layout
 * inside it.  Nothing here reloads on a route change: the host keeps the
 * panel mounted across navigation precisely so this document survives.
 */
const PluginPanelBody = ({ surface, pluginName }: PluginPanelBodyProps) => {
  const title = surface.label || `${pluginName} surface`;

  return <PluginSurfaceFrame url={surface.url} title={title} />;
};

export default PluginPanelBody;
